import NewCollaborator from '@/directory/newCollaborator'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/newCollaborator')({
  beforeLoad: ({ context }) => {
    // si no hay usuario, lo enviamos al login
    if (!context.user) {
      throw redirect({ to: '/login' });
    }

    // solo RRHH o Admin pueden acceder aquí
    const { isRRHH, isAdmin } = context.userRoles;
    if (!isRRHH && !isAdmin) {
      throw redirect({ to: '/unauthorized' });
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <NewCollaborator />)
}
